import styled from 'styled-components';
import { BATTLESHIP, KOALA, CALYPSO, OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import UIClickable from 'UIComponents/button/UIClickable';
import UIIcon from 'UIComponents/icon/UIIcon';
import { INNER_CARD_PADDING } from '../../config/cssConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledResponseFooter = styled(UIClickable).withConfig({
  displayName: "ResponseFooter__StyledResponseFooter",
  componentId: "hp4fn5-0"
})(["background:", ";border-radius:0 0 10px 10px;border-top:1px solid ", ";padding:", "px;gap:4px;display:flex;align-items:center;", "{color:", ";margin-bottom:0;line-height:normal;}"], KOALA, BATTLESHIP, INNER_CARD_PADDING, H5, OBSIDIAN);
const FooterIcon = styled(UIIcon).withConfig({
  displayName: "ResponseFooter__FooterIcon",
  componentId: "hp4fn5-1"
})(["line-height:normal;"]);
const ResponseFooter = ({
  expanded,
  onClick
}) => {
  return /*#__PURE__*/_jsxs(StyledResponseFooter, {
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(FooterIcon, {
      name: expanded ? 'up' : 'right',
      color: CALYPSO
    }), /*#__PURE__*/_jsx(H5, {
      children: expanded ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.response.response.showLess"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.response.response.showMore"
      })
    })]
  });
};
export default ResponseFooter;